import React, {Component} from 'react';
import Confirmation from './Confirmation';
import {
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button
} from 'reactstrap'

const R = require('ramda')

class Library extends Component {

  constructor(props) {
    super(props);
    this.state = {
      studentObjs: [],
      ids: '',
      alertDisplayed: false
    }
    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  componentDidMount() {
    let _this = this
    this.props.db.ref('students').once('value', snap => {
      let studentObjs = snap.val();
      _this.setState({studentObjs})
    })
  }

  save() {
    let _this = this;
    let ids = this.state.ids.replace(/[^0-9\n]+/g, '').split("\n");
    ids = R.uniq(ids);
    let studentObjs = R.mapObjIndexed((val, key) => {
      val.library = R.includes(val.stuID, ids);
      return val;
    }, this.state.studentObjs);
    console.log(studentObjs);
    this.props.db.ref('students').set(studentObjs)
      .then(() => {
        _this.setState({alertDisplayed: true});
        setTimeout(() => {
          _this.setState({alertDisplayed: false});
        }, 4000)
      });
  }

  onChange(evt) {
    let field = evt.currentTarget.getAttribute('name');
    this.setState(R.assoc(field, evt.currentTarget.value, {}))
  }

  render() {
    return (
      <div>
        {
          (this.state.alertDisplayed) ? <Confirmation dataType={'library'}/> : null
        }
        <Row className="master-detail-top-separator">
          <Col md={4}>
            <h5>Library update instructions:</h5>
            <h5>Copy the column of student ID numbers from the report generated by the library checkout system in the box on this page.  Non-standard ID numbers (with 'P' or other letters) will be adjusted by the LOP system.</h5>
            <h5>Note: The LOP system expects the complete list of ID numbers for all students that have overdue books and/or owe money.  The LOP system will clear the Library flag for all students that are NOT included in the list you paste here.</h5>
          </Col>
          <Col md={6}>
            <Form onSubmit={this.onSubmit}>
              <FormGroup>
                <Label for="stuID">Enter student IDs from the library checkout system...</Label>
                <Input type="textarea"
                       autoFocus
                       name="ids"
                       id="ids"
                       value={this.state.ids}
                       onChange={this.onChange}
                       className="id-text-box"
                       placeholder="Paste the IDs here" />
              </FormGroup>
            </Form>
          </Col>
          <Col md={2}>
            <Button color="primary" disabled={this.state.ids.length === 0} onClick={this.save}>Save</Button>
          </Col>
        </Row>
      </div>
    )
  }
}

export default Library



// WEBPACK FOOTER //
// ./src/views/Library.js